/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {NoHeaderStreamBankMutableList} from "./NoHeaderStreamBankMutableList";
import React from "react";

export const NoHeaderStreamBankImmutableList = props => (
    <NoHeaderStreamBankMutableList
        {...props}
        Editable={false}
    />
);
